import saveJWT from '@providers/apollo/saveJWT'

// pendiente borrar el refresh token en el server
export default async function logout() {
  saveJWT({})
}
